import app from "./firebase";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const VAPID_KEY = "BNNpk3pfJ5YpIDM4empdSrcqshwETm_ZFygGoHYC-uxnACfNUeywcCfu05wP_oTlXW_iviFQv0MaHr4XkpMZPVA";

export const getFcmTokenIfAvailable = async () => {
  try {
    // Browser support check
    const supported = await isSupported();

    if (!supported) {
      console.log("FCM is not supported in this browser.");
      return null;
    }

    // Notification permission
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied.");
      return null;
    }

    const messaging = getMessaging(app);

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
    });

    if (token) {
      console.log("FCM Token:", token);
      return token;
    }

    return null;
  } catch (error) {
    console.error("FCM Error:", error);
    return null;
  }
};